import * as React from "react";
const SvgSlot = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#969696", d: "M24.5 9.92 16 5 7.5 9.92l8.5 4.92zm-18 1.74v9.84l8.5 4.92v-9.84zM17 26.42l8.5-4.92v-9.84L17 16.58z" }));
export default SvgSlot;
